import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { Separator as Separator_ } from '@root/shared/ui-kit'

import type { LimitOrderModel } from '../../atoms'

type Props = {
  order: LimitOrderModel
}

export const LimitOrderSettings: React.FC<Props> = ({ order }) => {
  const { t } = useTranslation()

  const [valueHigh] = useAtom(order.triggerValueHigh)
  const [valueLow] = useAtom(order.triggerValueLow)

  if (order.type === 'buy') {
    const label =
      order.triggerType === 'absolute'
        ? t('trade.target-price')
        : t('trade.target-mcap')

    return (
      <Group>
        <Label>{label}</Label>
        <Price>
          <Numeric
            value={valueHigh || valueLow || 0}
            preset="amount-precise"
            currency="$"
          />
        </Price>
      </Group>
    )
  }

  const typeLabel =
    order.triggerType === 'absolute'
      ? t('trade.price-short')
      : t('trade.market-cap-short')

  return (
    <Columns>
      <Group>
        <Label>{`${t('trade.take-profit-short')}:${typeLabel}`}</Label>
        <Price>
          <Numeric
            value={valueHigh || '0'}
            preset="amount-precise"
            currency="$"
          />
        </Price>
      </Group>
      <Separator vertical />
      <Group>
        <Label>{`${t('trade.stop-loss-short')}:${typeLabel}`}</Label>
        <Price>
          <Numeric
            value={valueLow || '0'}
            preset="amount-precise"
            currency="$"
          />
        </Price>
      </Group>
    </Columns>
  )
}

const Columns = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 6px;
`

const Group = styled.div`
  display: grid;
`

const Label = styled.span`
  color: var(--text-9);
  text-align: right;
  text-transform: uppercase;

  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  white-space: nowrap;
`

const Separator = styled(Separator_)`
  background: var(--background-6);
  height: 23px;
  justify-self: center;
  margin-top: 2px;
`

const Price = styled.div`
  color: var(--text-12);
  text-align: right;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;

  white-space: nowrap;
`
